// @mui material components
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// Supabase renk paleti
const colors = {
    brand: '#3ECF8E',
    brandHover: '#24b47e',
    background: '#FFFFFF',
    border: '#E9ECEF',
    text: '#1F1F1F',
    textLight: '#4A5568',
    hover: '#F8F9FA',
};

const SupaCard = styled(Card)(({ theme }) => ({
    backgroundColor: colors.background,
    border: `1px solid ${colors.border}`,
    borderRadius: '4px',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    transition: 'border-color 0.2s ease',
    '&:hover': {
        borderColor: '#CBD5E0',
    },
}));

const ProductImage = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '160px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F8F9FA',
    borderBottom: `1px solid ${colors.border}`,
    padding: '16px',
    '& img': {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
}));

const ContentBox = styled(Box)(({ theme }) => ({
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-between',
}));

const Title = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 500,
    color: colors.text,
    marginBottom: '8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.2,
}));

const Description = styled(Typography)(({ theme }) => ({
    fontSize: '0.8rem',
    color: colors.textLight,
    marginBottom: '8px',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    lineHeight: 1.3,
}));

const SubTitle = styled(Typography)(({ theme }) => ({
    fontSize: '0.7rem',
    color: colors.textLight,
    fontWeight: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: '12px',
}));

const TagsContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
    marginBottom: 'auto',
}));

const Tag = styled(Chip)(({ theme }) => ({
    height: '20px',
    fontSize: '0.7rem',
    backgroundColor: '#F8FAFC',
    color: '#64748B',
    border: '1px solid #E2E8F0',
    borderRadius: '4px',
    '& .MuiChip-label': {
        padding: '0 8px',
    },
}));

const SelectButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '0.75rem',
    fontWeight: 500,
    padding: '6px 12px',
    borderRadius: '4px',
    backgroundColor: colors.brand,
    color: 'white',
    height: '32px',
    '&:hover': {
        backgroundColor: colors.brandHover,
    },
}));

function DefaultSheetTemplateCard({ image, title, description, setSelected, sheetTemplate, tags }) {
    return (
        <SupaCard onClick={() => setSelected(sheetTemplate)}>
            <ProductImage>
                <img src={image} alt={title} />
            </ProductImage>
            <ContentBox>
                <div>
                    <Title title={title}>{title}</Title>

                    {description && <Description title={description}>{description}</Description>}

                    {sheetTemplate.subtitle && (
                        <SubTitle title={sheetTemplate.subtitle}>{sheetTemplate.subtitle}</SubTitle>
                    )}
                </div>

                <SelectButton variant="contained" disableElevation fullWidth>
                    ŞABLONU SEÇ
                </SelectButton>
            </ContentBox>
        </SupaCard>
    );
}

export default DefaultSheetTemplateCard;
